// extracted by mini-css-extract-plugin
export default {"container":"Customize_container__qGWoG"};